import React, { useState } from 'react';
import styles from './AddBESS.module.css';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { FormGroup, MenuItem, Select } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { Notify } from 'notiflix';
import { useTranslation } from 'react-i18next';

function ModulesFormGroup({ modules, setModules }) {
  const { t } = useTranslation();
  const moduleTemplates = useSelector(
    (state) => state.moduleReducer.moduleTemplates
  );
  const [selectedTemplate, setSelectedTemplate] = useState(
    moduleTemplates[0].carModel
  );
  const [numberOfModules, setNumberOfModules] = useState(0);
  let moduleInfoForms = [];

  const updateNumberOfModules = (number) => {
    if (!selectedTemplate) {
      Notify.warning(t('selectTemplate'));
      return;
    }

    let modulesCopy = [...modules];
    if (number > modulesCopy.length) {
      for (let i = modulesCopy.length; i < number; i++) {
        modulesCopy.push({
          mileage: 0,
          serialNumber: '',
          moduleTemplateId: selectedTemplate.id
        });
      }
    } else {
      modulesCopy = modulesCopy.slice(0, number);
    }
    setModules(modulesCopy);
    moduleInfoForms = [];
    setNumberOfModules(number);
  };

  const updateModuleInfo = (index, key, value) => {
    const modulesCopy = [...modules];
    modulesCopy[index][key] = value;
    setModules(modulesCopy);
  };

  modules.forEach((module, i) => {
    const mileageLabel = `${t('Module')} ${i + 1} ${t('mileage')}`;
    const serialNumberLabel = `${t('Module')} ${i + 1} ${t('serialNumber')}`;
    moduleInfoForms.push(
      <div className={styles.moduleInfoContainer} key={i}>
        <FormControl required={true} variant="outlined">
          <InputLabel htmlFor="component-outlined">{mileageLabel}</InputLabel>
          <OutlinedInput
            id="component-outlined"
            type={'number'}
            value={modules[i].mileage}
            onChange={(e) =>
              updateModuleInfo(i, 'mileage', parseInt(e.target.value))
            }
            label={mileageLabel}
          />
        </FormControl>
        <FormControl required={true} variant="outlined">
          <InputLabel htmlFor="component-outlined">
            {serialNumberLabel}
          </InputLabel>
          <OutlinedInput
            id="component-outlined"
            value={modules[i].serialNumber}
            onChange={(e) =>
              updateModuleInfo(i, 'serialNumber', e.target.value)
            }
            label={serialNumberLabel}
          />
        </FormControl>
      </div>
    );
  });

  return (
    <FormGroup>
      <div className={styles.topModuleInfo}>
        <FormControl required={true} variant="outlined">
          <InputLabel htmlFor="component-outlined">
            {t('NumberOfModules')}
          </InputLabel>
          <OutlinedInput
            id="component-outlined"
            type={'number'}
            value={numberOfModules}
            onChange={(e) => updateNumberOfModules(e.target.value)}
            label={t('NumberOfModules')}
          />
        </FormControl>
        <FormControl required={true} variant="outlined">
          <InputLabel
            id={'module-template-select-label'}
            htmlFor="component-outlined"
          >
            {t('ModuleTemplate')}
          </InputLabel>
          <Select
            labelId={'module-template-select-label'}
            label={t('ModuleTemplate')}
            value={selectedTemplate.carModel}
            onChange={(e) =>
              setSelectedTemplate(
                moduleTemplates.find(
                  (template) => template.carModel === e.target.value
                )
              )
            }
          >
            {moduleTemplates.map((template) => (
              <MenuItem key={template.id} value={template.carModel}>
                {`${template.carModel} - ${template.moduleType}`}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className={styles.modulesInfoContainer}>{moduleInfoForms}</div>
    </FormGroup>
  );
}

export default ModulesFormGroup;
